module.exports = __webpack_public_path__ + "img/guns.a34b4598.png";